export default __webpack_public_path__ + "static/DSC_0008-d3982800355c2416b5522230331672de.jpg";